export const GET_USERS_REQUESTED = 'GET_USERS_REQUESTED';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';

// export const GET_FAVOURITE_SUCCESS = 'GET_FAVOURITE_SUCCESS';
// export const GET_FAVOURITE_FAILED = 'GET_FAVOURITE_FAILED';
// export const GET_FAVOURITE_REQUESTED = 'GET_FAVOURITE_REQUESTED'